export type MediaCategory = "movie" | "tv" | "variety";

export interface MediaItem {
  id: string;
  title: string;
  category: MediaCategory;
  region: string;
  year: number;
  cover: string;
  summary: string;
  content: string[];
  director?: string;
  cast?: string[];
  releaseDate: string;
  views: number;
  rating: number;
  tags: string[];
  isFeatured?: boolean;
}

export interface CategoryMeta {
  key: MediaCategory;
  name: string;
  path: string;
  desc: string;
  icon: string;
  cover: string;
}

export const CATEGORY_LABELS: Record<MediaCategory, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const REGION_OPTIONS = ["全部", "国内", "欧美", "日韩"] as const;
export const CATEGORY_OPTIONS: Array<"全部" | MediaCategory> = ["全部", "movie", "tv", "variety"];
export const YEAR_OPTIONS = ["全部", "2026", "2025", "2024", "2023"] as const;
export const SORT_OPTIONS = [
  { key: "time", label: "最新时间" },
  { key: "hot", label: "按热度" },
  { key: "rating", label: "按评分" },
] as const;

export type SortKey = (typeof SORT_OPTIONS)[number]["key"];